import { oddsKeyArray, oddsZodiacArray, oddsColorArray, oddsElement, getLocateText } from '../oddsKeyArray'

const initSpKey = () => {
  const mainAndSup = groupKey => {
    return {
      mainKey: 'sp_num',
      supKey: '',
      groupKey
    }
  }
  let groupKey = ''

  const keyObj = oddsKeyArray.reduce((root, oddsKey) => {
    groupKey = `SP:${oddsKey}`
    root[groupKey] = mainAndSup(groupKey)
    return root
  }, {})

  for (let i = 1; i <= 49; i++) {
    groupKey = getLocateText(i, 'SP')
    keyObj[groupKey] = mainAndSup(groupKey)
  }
  return keyObj
}

const initStraightSPNumKey = () => {
  const mainKey = 'straight_sp_num'
  const keyArrayConfig = ['one', 'two', 'three', 'four', 'five', 'six']
  let groupKey = ''

  return keyArrayConfig.reduce((root, enNumber, index) => {
    const betIndex = index + 1
    const mainAndSup = groupKey => {
      return {
        mainKey,
        supKey: `straight_sp_${enNumber}`,
        groupKey
      }
    }

    for (let i = 1; i <= 49; i++) {
      groupKey = getLocateText(i, betIndex)
      root[groupKey] = mainAndSup(groupKey)
    }

    for (const item of oddsKeyArray) {
      root[`${betIndex}:${item}`] = mainAndSup(`${betIndex}:${item}`)
      root[`${betIndex}:DIGIT:SUM:${item}`] = mainAndSup(`${betIndex}:DIGIT:SUM:${item}`)
    }

    for (const color of oddsColorArray) {
      groupKey = `${betIndex}:${color}`
      root[groupKey] = mainAndSup(groupKey)
    }

    root[`${betIndex}:TAIL:OVER`] = mainAndSup(`${betIndex}:TAIL:OVER`)
    root[`${betIndex}:TAIL:UNDER`] = mainAndSup(`${betIndex}:TAIL:UNDER`)

    return root
  }, {})
}

const initStraightNumKey = () => {
  const mainKey = 'straight_num'
  const numMainAndSup = groupKey => {
    return {
      mainKey,
      supKey: 'straight_num',
      groupKey

    }
  }
  const totalMainAndSup = groupKey => {
    return {
      mainKey,
      supKey: 'total_sum',
      groupKey

    }
  }
  let groupKey = ''

  const keyObj = oddsKeyArray.reduce((root, oddsKey) => {
    groupKey = `ALL:SUM:${oddsKey}`

    root[groupKey] = totalMainAndSup(groupKey)

    return root
  }, {})

  for (let i = 1; i <= 49; i++) {
    groupKey = `${i}:MATCH:NL`
    keyObj[groupKey] = numMainAndSup(groupKey)
  }

  return keyObj
}

const initTwoSideKey = () => {
  const mainAndSup = groupKey => {
    return {
      mainKey: 'two_side',
      supKey: 'title_sp_num',
      groupKey
    }
  }
  const spZodiacArray = ['SKY', 'GROUND', 'FRONT', 'BACK', 'POULTRY', 'WILD']
  const keyObj = {
    'SP:TAIL:OVER': mainAndSup('SP:TAIL:OVER'),
    'SP:TAIL:UNDER': mainAndSup('SP:TAIL:UNDER')
  }

  for (const oddsKey of spZodiacArray) {
    const groupKey = `SP:ZODIAC:${oddsKey}`
    keyObj[groupKey] = mainAndSup(groupKey)
  }

  for (const key of oddsKeyArray) {
    keyObj[`SP:DIGIT:SUM:${key}`] = mainAndSup(`SP:DIGIT:SUM:${key}`)
  }
  oddsKeyArray.slice(0, 2).forEach(odd => {
    keyObj[`SP:${odd}:ODD`] = mainAndSup(`SP:${odd}:ODD`)
    keyObj[`SP:${odd}:EVEN`] = mainAndSup(`SP:${odd}:EVEN`)
  })
  oddsColorArray.forEach(color => {
    keyObj[`SP:${color}`] = mainAndSup(`SP:${color}`)
  })

  return keyObj
}

const initLinkKey = () => {
  const mainKey = 'link_num'
  return {
    'MIX:CHOOSE:2:MATCH:2:NL': {
      mainKey,
      supKey: 'set_two_get_two'
    },
    'MIX:CHOOSE:2:MATCH:1:NL:SP': {
      mainKey,
      supKey: 'set_two_mix'
    },
    'CHOOSE:2:MATCH:2:NL': {
      mainKey,
      supKey: 'set_two_all_num'
    },
    'MIX:CHOOSE:3:MATCH:2:NL': {
      mainKey,
      supKey: 'set_three_get_two'
    },
    'MIX:CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'set_three_get_two'
    },
    'CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'set_three_all_num'
    },
    'CHOOSE:4:MATCH:4:NL': {
      mainKey,
      supKey: 'set_four_all_num'
    },
    'CHOOSE:2:MATCH:1:NL:SP': {
      mainKey,
      supKey: 'set_two_for_sp_and_straight'
    }
  }
}

const initColorWaveKey = () => {
  const mainKey = 'color_wave'
  const sevenKey = groupKey => {
    return {
      mainKey,
      supKey: 'total_sum',
      groupKey
    }
  }
  const spColorKey = (supKey, groupKey) => {
    return {
      mainKey,
      supKey,
      groupKey
    }
  }
  const keyObj = { 'ALL:COLOR:TIE': sevenKey('ALL:COLOR:TIE') }

  for (const key of oddsColorArray) {
    keyObj[`ALL:COLOR:${key}`] = sevenKey(`ALL:COLOR:${key}`)

    for (const oddsKey of oddsKeyArray) {
      const supKey = `${key.toLowerCase()}_wave`

      keyObj[`SP:${key}:${oddsKey}`] = spColorKey(supKey, `SP:${key}:${oddsKey}`)

      if (oddsKey === 'ODD' || oddsKey === 'EVEN') {
        keyObj[`SP:${key}:OVER:${oddsKey}`] = spColorKey(supKey, `SP:${key}:OVER:${oddsKey}`)
        keyObj[`SP:${key}:UNDER:${oddsKey}`] = spColorKey(supKey, `SP:${key}:UNDER:${oddsKey}`)
      }
    }
  }

  return keyObj
}

const initZodiacKey = () => {
  const mainKey = 'zodiac'
  const spZodiacKey = groupKey => {
    return {
      mainKey,
      supKey: 'sp_zodiac',
      groupKey
    }
  }
  const combinedZodiacKey = {
    mainKey,
    supKey: 'combine_zodiac'
  }
  const oneZodiacKey = groupKey => {
    return {
      mainKey,
      supKey: 'one_zodiac',
      groupKey
    }
  }
  const totalZodiacKey = groupKey => {
    return {
      mainKey,
      supKey: 'total_zodiac',
      groupKey
    }
  }
  const straightZodiacKey = groupKey => {
    return {
      mainKey,
      supKey: 'straight_zodiac',
      groupKey
    }
  }
  const keyObj = {
    'ALL:IN:ZODIAC:ODD': totalZodiacKey('ALL:IN:ZODIAC:ODD'),
    'ALL:IN:ZODIAC:EVEN': totalZodiacKey('ALL:IN:ZODIAC:EVEN')
  }

  oddsZodiacArray.forEach((item, index) => {
    keyObj[`SP:ZODIAC:${item}`] = spZodiacKey(`SP:ZODIAC:${item}`)
    keyObj[`ALL:ZODIAC:${item}`] = oneZodiacKey(`ALL:ZODIAC:${item}`)
    keyObj[`NL:ZODIAC:${item}`] = straightZodiacKey(`NL:ZODIAC:${item}`)

    if (index >= 2) {
      keyObj[`SP:IN:ZODIAC:${index}`] = combinedZodiacKey
      if (index <= 7)keyObj[`ALL:IN:ZODIAC:${index}`] = totalZodiacKey(`ALL:IN:ZODIAC:${index}`)
    }
  })

  return keyObj
}

const initSpTailNum = () => {
  const keyObj = {}

  for (let i = 0; i <= 9; i++) {
    const groupKey = `ALL:TAIL:${i}`
    const keyStr = 'sp_tail_num'
    keyObj[groupKey] = {
      mainKey: keyStr,
      supKey: keyStr,
      groupKey
    }
  }

  return keyObj
}

const initHeadTail = () => {
  const keyObj = {}
  const mainKey = 'sp_head_tail'
  let groupKey = ''

  for (let i = 0; i <= 9; i++) {
    if (i <= 4) {
      groupKey = `SP:HEAD:${i}`
      keyObj[groupKey] = {
        mainKey,
        supKey: 'sp_head',
        groupKey
      }
    }

    groupKey = `SP:TAIL:${i}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'sp_tail',
      groupKey
    }
  }

  return keyObj
}
// 段
const initLinkZodiac = () => {
  const mainKey = 'link_zodiac'
  const keyArrayConfig = ['two', 'three', 'four', 'five']

  return keyArrayConfig.reduce((root, enNumber, index) => {
    for (const key of oddsZodiacArray) {
      const number = index + 2
      root[`ALL:ZODIAC:CHOOSE:${number}:MATCH:${number}:${key}`] = {
        mainKey,
        supKey: `${enNumber}_zodiac`
      }
    }

    return root
  }, {})
}

const initLinkTail = () => {
  const mainKey = 'link_tail'
  const keyArrayConfig = ['two', 'three', 'four', 'five']

  return keyArrayConfig.reduce((root, enNumber, index) => {
    for (let i = 0; i <= 9; i++) {
      const number = index + 2
      root[`ALL:TAIL:CHOOSE:${number}:MATCH:${number}:${i}`] = {
        mainKey,
        supKey: `${enNumber}_tail`
      }
    }

    return root
  }, {})
}

const initElementKey = () => {
  return oddsElement.reduce((root, element) => {
    const groupKey = `SP:${element}`
    root[groupKey] = {
      mainKey: 'element',
      supKey: '',
      groupKey
    }
    return root
  }, {})
}

const initSelectWithoutTargetKey = () => {
  const keyObj = {}

  for (let i = 5; i <= 12; i++) {
    keyObj[`CHOOSE:${i}:MATCH:0`] = {
      mainKey: 'select_without_target',
      supKey: ''
    }
  }

  return keyObj
}

export default {
  ...initSpKey(),
  ...initStraightSPNumKey(),
  ...initStraightNumKey(),
  ...initTwoSideKey(),
  ...initLinkKey(),
  ...initColorWaveKey(),
  ...initZodiacKey(),
  ...initSpTailNum(),
  ...initHeadTail(),
  ...initLinkZodiac(),
  ...initLinkTail(),
  ...initElementKey(),
  ...initSelectWithoutTargetKey()
}
